import {Component, OnDestroy, OnInit} from "@angular/core";
import {BaseComponent} from "../../base.component";
import {ShareableService} from "./shareable.service";
import {LoggerService} from "../../common/logger.service";
import {UserService} from "../../common/user.service";
import {MarkupService} from "../../common/markup.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Constants} from "../../constants";
import {IShareableCart, IShareableCartProduct} from "../../cart/cart-models";
import {TranslateService} from "../../translation/translate.service";
import {UsanaCookieService} from "../../common/usana-cookie.service";
import {EnrollPcService} from "../../enroll/pc/enroll-pc.service";
import {Subscription, throwError} from "rxjs";
import * as _ from "lodash";
import {CartService} from "../../cart/cart.service";
import {IShareParams, ISponsorDetails} from "../social-models";
import {ShareableUtil} from "../shareable-util";
import {IRestResponse} from "../../common/rest-response.model";
import {SponsorService} from "../../common/sponsor.service";
import {catchError, find, map} from "rxjs/operators";
import {CustomerUtil} from "../../util/customer-util";

@Component({
    selector: 'shareable-cart',
    templateUrl: './shareable-cart.component.html',
    styleUrls: ['./shareable-cart.component.scss'],
    standalone: false
})
export class ShareableCartComponent extends BaseComponent implements OnInit, OnDestroy {

    shareableProducts: IShareableCartProduct[];
    productsInCart: boolean = false;
    headerDescription: string;
    sponsorName: string;
    subscription: Subscription;
    busy: boolean = false;
    params: IShareParams = {};

    constructor(
        loggerService: LoggerService,
        private shareableService: ShareableService,
        private userService: UserService,
        private cartService: CartService,
        private markupService: MarkupService,
        private translateService: TranslateService,
        private enrollPcService: EnrollPcService,
        private usanaCookieService: UsanaCookieService,
        private sponsorService: SponsorService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.params.shareId = this.route.snapshot.queryParamMap.get(Constants.SHARE_ID_PARAM);
        this.params.shareType = this.route.snapshot.queryParamMap.get(Constants.SHARE_TYPE_PARAM);
        this.params.cartInit = this.route.snapshot.queryParamMap.get(Constants.CART_INIT_PARAM);
        if (ShareableUtil.isCartShare(this.params)) {
            this.getShareableCart();
        } else {
            this.router.navigate([Constants.LANDING_STATE]);
        }

        this.subscription = this.cartService.cart$.subscribe(cart => {
            if (!_.isEmpty(cart)) {
                this.productsInCart = cart.products.length > 0;
            }
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    get showSignup(): boolean {
        return this.allowPcSignup && !this.showCart;
    }

    getShareableCart() {
        this.busy = true;
        this.shareableService.getCartProducts(ShareableUtil.getShareCartInit(this.params)).subscribe((response: IRestResponse) => {
            if (response.success) {
                const shareableCart: IShareableCart = response.message;
                if (!!shareableCart && shareableCart.products.length > 0) {
                    this.shareableProducts = shareableCart.products;
                    this.markupService.setToDefaultTitle();
                    this.setSponsor();
                    this.shareableService.displayUnavailableProductsMessage(shareableCart);
                }
            }
            this.busy = false;
        }, (error: any) => {
            this.log.error("getShareableCart", error);
            this.busy = false;
        });
    }

    setSponsor() {
        this.sponsorService.sponsorDetailsSubject.watch().pipe(
            find((sponsorDetails: ISponsorDetails) => ShareableUtil.isSponsorDetailsPresent(sponsorDetails)),
            map((sponsorDetails: ISponsorDetails) => {
                // we want to use pc sponsor name if it is present
                this.sponsorName = sponsorDetails?.pcReferralOtherName || sponsorDetails?.pcReferralName || CustomerUtil.getSponsorDisplayName(sponsorDetails);
                if (this.sponsorName) {
                    this.setHeaderDescription();
                }
            }),
            catchError((error) => {
                this.log.error("getCustomerName", error);
                return throwError(error);
            })
        ).subscribe();
    }

    setHeaderDescription() {
        this.translateService.translateRequest({
            tag: "cart.shareable.landing.intro.description",
            replacements: new Map([[Constants.NAME_KEY, this.sponsorName]])
        }).then((translation: string) => {
            this.headerDescription = translation;
        });
    }

}
